import React from 'react';

import { Slider } from '../../../WidgetConfiguratorComponents/FormGroups';

const min = 1;
const max = 8;
const marks = {
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
};
const label = 'Bin step size:';

export const BinStepSizeFormGroup = (props) => {
    const { onChange, binStepSize } = props;

    return <Slider label={label} onChange={onChange} value={binStepSize} min={min} max={max} marks={marks} />;
};
